<template>
    <!--
            作者：kmdshop
            时间：2023-06-30
            描述：插件中心-短信群发-发送任务
        -->
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
      </div>
      <!-- <div class="common-level-rail">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加发送任务</el-button>
      </div> -->
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
              <el-table-column prop="sms_task_id" label="任务ID" width="70"></el-table-column>
              <el-table-column prop="name" label="任务名称" width="100"></el-table-column>
              <el-table-column  label="短信签名">
                <template slot-scope="scope">
                  <span>{{ scope.row.smsSign.name }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="短信模板">
                <template slot-scope="scope">
                  <span>{{ scope.row.smsTemplate.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="总数量"></el-table-column>
              <el-table-column prop="success_num" label="成功数量"></el-table-column>
              <el-table-column prop="error_num" label="失败数量"></el-table-column>
              <el-table-column prop="message" label="短信结果"></el-table-column>
              <el-table-column prop="task_status" label="请求状态"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
              message
              <el-table-column prop="create_time" label="添加时间" width="135"></el-table-column>
              <!-- <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small">发送短信</el-button>  
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
             :page-size="pageSize" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>

      <Add
      v-if="open_add"
      :open_add="open_add"
      @closeDialog="closeDialog('add')"
    ></Add>

    <Edit
      v-if="open_edit"
      :open_edit="open_edit"
      :model="apiModel"
      @closeDialog="closeDialog('edit')"
    ></Edit>
    </div>
  </template>
  <script>
    import SmsApi from '@/api/sms.js';
    import Add from "./task/add.vue";
    import Edit from "./task/edit.vue";
    export default {
      components:{
        Add,
        Edit
     },
      data() {
        return {
          formInline: {},
          form: {},
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*是否加载完成*/
          loading: true,

          open_add:false,
          open_edit:false,
        };
      },
      created() {
        /*获取列表*/
        this.getData();
      },
      methods: {
        /*获取列表*/
        getData() {
          let self = this;
          let Params = {};
          Params.code = "paginate"
          Params.limit = {
            page : self.curPage,
            list_rows : self.pageSize,
          }
          SmsApi.taskList(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total
            })
            .catch(error => {});
        },
        /*选择第几页*/
        handleCurrentChange(val) {
          let self = this;
          self.curPage = val;
          self.loading = true;
          self.getData();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getData();
        },
        /*添加*/
        addClick() {
          this.open_add = true;
        },
        /*修改*/
        editClick(e) {
          let self = this;
          self.$router.push('/plus/data/analysis/index');
        },
        /*删除优惠券*/
        deleteClick(e) {
          let self = this;
          self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.loading = true;
            SmsApi.del({
                coupon_id: e.coupon_id
              }, true).then(data => {
                self.loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getData();
  
              })
              .catch(error => {
                self.loading = false;
              });
  
          }).catch(() => {
            self.loading = false;
          });
        },
         /* 关闭编辑框 */
        closeDialog(type) {
            if(type == 'add'){
                this.open_add = false;
            }else{
                this.open_edit = false;
            }
           
            this.getData()
        },
  
      }
    };
  </script>
  
  <style>
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/data/sms/index/task.vue